const requestPrefix = '/api/security/uco';

export const activeLicense = {
  selAuthorizePage: `${requestPrefix}/security/v1/gateway/xc/getUserInfo`,
  createProcessId: `${requestPrefix}/security/v1/gateway/xc/createProcessId`,
  selAuthorizePage: `${requestPrefix}/security/v1/gateway/xc/selAuthorizePage`,
  saveAuthorizeInfo: `${requestPrefix}/security/v1/gateway/xc/saveAuthorizeInfo`,
  // 批量移除授权信息
  removeAuthorizeInfos: `${requestPrefix}/security/v1/gateway/xc/removeAuthorizeInfos`,
  // 下载授权码Excel清单模板
  downloadLicenseKeyTemplate: `${requestPrefix}/security/v1/gateway/xc/downloadLicenseKeyTemplate`,
  // 通过文件获取授权码信息列表接口
  getAuthorizeListByFile: `${requestPrefix}/security/v1/gateway/xc/getAuthorizeListByFile`,

  // selAuthorizePage: '/uco/security/v1/gateway/xc/selAuthorizePage',
  // cloudList: '/pco/v1/promotion/common/cloud/list',
  // couponList: '/pco/v1/promotion/user/coupon/list',
  // couponDetail: '/pco/v1/promotion/user/coupon/detail'
  checkDeviceInfo: `${requestPrefix}/security/v1/gateway/xc/checkDeviceInfo`, // 检验设备是否弹窗
  getCustomizeDeviceInfo: `${requestPrefix}/security/v1/gateway/xc/getCustomizeDeviceInfo`, // 查询自定义设备标识信息列表
  getCustomizeDeviceFile: `${requestPrefix}/security/v1/gateway/xc/getCustomizeDeviceFile`, // 通过自定义设备标识信息查询文件
  inputDeviceInfo: `${requestPrefix}/security/v1/gateway/xc/inputDeviceInfo`, // (批量)录入设备信息
  // 授权码批量追加
  saveAuthorizeInfoBatch: `${requestPrefix}/security/v1/gateway/xc/saveAuthorizeInfoBatch`,
  // 校验下一步合法性
  step: `${requestPrefix}/security/v1/gateway/xc/step`,
  // 解析二维码
  parseQrCode: `${requestPrefix}/security/v1/gateway/xc/parseQrCode`,
  // 获取验证码
  captcha: '/api/user/pco/user/v1/captcha',
  // 验证 验证码
  verification: '/api/user/pco/user/v1/captcha/verification',
  // 用户数据录入
  saveUserInfo: `${requestPrefix}/security/v1/gateway/xc/saveUserInfo`,
  // 设备信息文件上传
  uploadDeviceFile: `${requestPrefix}/security/v1/gateway/xc/uploadDeviceFile`,
  // 设备信息文件上传
  uploadOldActivationFile: `${requestPrefix}/security/v1/gateway/xc/uploadOldActivationFile`,
  // 批量录入设备信息
  inputDeviceInfo: `${requestPrefix}/security/v1/gateway/xc/inputDeviceInfo`,
  // 查询授权信息列表  全部
  selAuthorizeList: `${requestPrefix}/security/v1/gateway/xc/selAuthorizeList`,
  // 激活授权码
  submitActivation: `${requestPrefix}/security/v1/gateway/xc/submitActivation`,
  // 提交第二步并验证合法性
  stepValidate: `${requestPrefix}/security/v1/gateway/xc/stepValidate`,
  // 批量获取激活信息 --- 激活结果批量下载
  fileDownloadBatch: `${requestPrefix}/security/v1/gateway/xc/fileDownloadBatch`,
  // 获取用户数据信息
  getUserInfo: `${requestPrefix}/security/v1/gateway/xc/getUserInfo`,
  // 重置
  resetApi: `${requestPrefix}/security/v1/gateway/xc/reset`,
  // 取消
  cancelDeviceFile: `${requestPrefix}/security/v1/gateway/xc/cancelDeviceFile`,
  // 下载激活文件
  downloadActivationFile: `${requestPrefix}/security/v1/gateway/xc/downloadActivationFile`,
  // 复制文件
  copyDeviceFile: `${requestPrefix}/security/v1/gateway/xc/copyDeviceFile`,
};
